<template>
    <header class="programs-header">
        <div class="header" v-if="is_app">
            <div  class="title">
                <h2>Recruitment</h2>
                <queue-progress />
            </div>
            <Button v-if="had_programs" :is_disabled="$store.state.merchant_disabeld || !permission_recruitment.createApplications.permission" size="32" color="dark-blue" :border_r="6" :flex="true" @click="addApp">
                <svg-icon name="plus" /> New Application
            </Button>
        </div>
    </header>
</template>

<script>
import Button from '@/components/ui/Button.vue';

export default {
    name: 'CreatorHeader',

    data() {
        return {
        }
    },

    props:{
        is_app:{
            type: Boolean,
            default: true,
        },
        had_programs:{
            type: Boolean,
            default: true,

        },
    },

    components: {
        Button,
    },
    computed: {
        permission_recruitment(){
            return this.$store.state.user_data?.permission_list?.recruitment;
        },
    },
    methods: {
        addApp() {
            this.$emit('create');
        },
    }
}
</script>
<style lang="scss">
    .programs-header {

        .header {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .title {
                flex: 1;
                display: flex;
                align-items: center;
                
                & > h2 {
                    font: var(--font-demi-36);
                    color: black;
                }
            }

        }

    }
</style>